var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Router, loc } from "../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import Backbone from "../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import oktaJQueryStatic from "../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import Settings from "../models/Settings.js";
import Bundles from "../util/Bundles.js";
import fn$2 from "../util/BrowserFeatures.js";
import fn from "../util/ColorsUtil.js";
import Enums from "../util/Enums.js";
import { ConfigError } from "../util/Errors.js";
import Logger from "../util/Logger.js";
import LanguageUtil from "../util/LanguageUtil.js";
import AuthContainer from "../v1/views/shared/AuthContainer.js";
import Header from "../v1/views/shared/Header.js";
import AppState from "./models/AppState.js";
import sessionStorageHelper from "./client/sessionStorageHelper.js";
import "@okta/okta-auth-js";
import { startLoginFlow } from "./client/startLoginFlow.js";
import { handleConfiguredFlow } from "./client/handleConfiguredFlow.js";
import { updateAppState } from "./client/updateAppState.js";
import fn$1 from "../util/CookieUtil.js";
import { formatError } from "./client/formatError.js";
import IonResponseHelper from "./ion/IonResponseHelper.js";
class BaseLoginRouter extends Router {
  // also set on prototype
  constructor(options) {
    super(options);
    this.Events = Backbone.Events;
    this.hasControllerRendered = false;
    this.settings = void 0;
    this.appState = void 0;
    this.hooks = void 0;
    this.header = void 0;
    if (!options.globalSuccessFn) {
      options.globalSuccessFn = function() {
      };
    }
    if (!options.globalErrorFn) {
      options.globalErrorFn = function(err) {
        Logger.error(err);
      };
    }
    this.settings = new Settings(oktaUnderscore.omit(options, "el", "hooks"), {
      parse: true
    });
    if (!options.el) {
      this.settings.callGlobalError(new ConfigError(loc("error.required.el")));
    }
    oktaJQueryStatic("body > div").on("click", function() {
    });
    this.hooks = options.hooks;
    this.appState = new AppState({}, {
      settings: this.settings,
      hooks: this.hooks
    });
    const wrapper = new AuthContainer({
      appState: this.appState
    });
    oktaJQueryStatic(options.el).append(wrapper.render().$el);
    this.el = `#${Enums.WIDGET_CONTAINER_ID}`;
    this.header = new Header({
      el: this.el,
      appState: this.appState,
      settings: this.settings
    });
    this.hide();
    this.listenTo(this.appState, "change:deviceFingerprint", this.updateDeviceFingerprint);
    this.listenTo(this.appState, "restartLoginFlow", this.restartLoginFlow);
  }
  updateDeviceFingerprint() {
    const authClient = this.settings.getAuthClient();
    const fingerprint = this.appState.get("deviceFingerprint");
    if (fingerprint) {
      authClient.http.setRequestHeader("X-Device-Fingerprint", fingerprint);
    }
  }
  handleIdxResponseFailure() {
    return __async(this, arguments, function* (error = {
      error: "unknown",
      details: void 0
    }) {
      error = formatError(error);
      yield updateAppState(this.appState, error.details);
    });
  }
  // Generic error handler for all exceptions
  handleError() {
    return __async(this, arguments, function* (error = {
      error: "unknown",
      details: void 0
    }) {
      const formattedError = formatError(__spreadValues({}, error));
      yield updateAppState(this.appState, formattedError.details);
    });
  }
  /* eslint max-statements: [2, 36], complexity: [2, 16] */
  render(_0) {
    return __async(this, arguments, function* (Controller, options = {}) {
      if (sessionStorageHelper.getLastInitiatedLoginUrl() !== window.location.href) {
        sessionStorageHelper.removeStateHandle();
      }
      if (!this.header.rendered()) {
        this.el = this.header.render().getContentEl();
      }
      if (!Bundles.isLoaded(this.settings.get("languageCode"))) {
        yield LanguageUtil.loadLanguage(this.appState, this.settings);
      }
      let error;
      try {
        let idxResp = yield startLoginFlow(this.settings);
        if (idxResp.error) {
          yield this.handleIdxResponseFailure(idxResp.error);
        } else {
          if (this.settings.get("flow") && !this.hasControllerRendered) {
            idxResp = yield handleConfiguredFlow(idxResp, this.settings);
          }
          if (!idxResp.requestDidSucceed && IonResponseHelper.isIdxSessionExpiredError(idxResp)) {
            const authClient = this.settings.getAuthClient();
            authClient.transactionManager.clear();
          }
          yield updateAppState(this.appState, idxResp);
        }
      } catch (exception) {
        var _exception$is;
        if ((_exception$is = exception.is) !== null && _exception$is !== void 0 && _exception$is.call(exception, "terminal")) {
          this.appState.setNonIdxError(exception);
        } else {
          error = exception;
          yield this.handleError(exception);
        }
      } finally {
        this.settings.unset("stateToken");
        this.settings.unset("proxyIdxResponse");
      }
      if (this.settings.get("colors.brand") && !fn.isLoaded()) {
        const colors = {
          brand: this.settings.get("colors.brand")
        };
        const cspNonce = this.settings.get("cspNonce");
        fn.addStyle(colors, cspNonce);
      }
      this.show();
      this.unload();
      const controllerOptions = oktaUnderscore.extend({
        el: this.el,
        settings: this.settings,
        appState: this.appState
      }, options);
      this.controller = new Controller(controllerOptions);
      this.listenTo(this.controller, "all", this.trigger);
      this.controller.render();
      this.hasControllerRendered = true;
      if (error) {
        this.settings.callGlobalError(error);
      }
    });
  }
  /**
    * When "Remember My Username" is enabled, we save the identifier in a cookie
    * so that the next time the user visits the SIW, the identifier field can be 
    * pre-filled with this value.
   */
  updateIdentifierCookie(idxResponse) {
    if (this.settings.get("features.rememberMe")) {
      var _idxResponse$context;
      const user = idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.user;
      const {
        identifier
      } = (user === null || user === void 0 ? void 0 : user.value) || {};
      if (identifier) {
        fn$1.setUsernameCookie(identifier);
      }
    } else {
      fn$1.removeUsernameCookie();
    }
  }
  hasAuthenticationSucceeded(idxResponse) {
    var _idxResponse$rawIdxSt, _idxResponse$rawIdxSt2;
    return (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt === void 0 ? void 0 : _idxResponse$rawIdxSt.success) || (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt2 = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt2 === void 0 ? void 0 : _idxResponse$rawIdxSt2.successWithInteractionCode);
  }
  restartLoginFlow(flow) {
    var _ref;
    this.settings.getAuthClient().transactionManager.clear();
    this.appState.set("idx", void 0);
    const authClient = this.settings.getAuthClient();
    delete authClient.options["recoveryToken"];
    this.settings.unset("recoveryToken");
    this.settings.unset("otp");
    this.controller.stopListening();
    authClient.idx.setFlow((_ref = flow !== null && flow !== void 0 ? flow : this.settings.get("flow")) !== null && _ref !== void 0 ? _ref : "default");
    this.render(this.controller.constructor);
  }
  start() {
    const pushState = fn$2.supportsPushState();
    Router.prototype.start.call(this, {
      pushState
    });
  }
  hide() {
    this.header.$el.hide();
  }
  show() {
    this.header.$el.show();
  }
  remove() {
    this.unload();
    this.header.$el.remove();
    this.stopListening(this.appState);
    this.stopListening(this.settings);
    Bundles.remove();
    Backbone.history.stop();
  }
}
BaseLoginRouter.prototype.Events = Backbone.Events;
export { BaseLoginRouter as default };
